import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorinterfaceComponent } from './colorinterface.component';
import { TemplatesComponent } from './templates/templates.component';
import { CustomComponent } from './custom/custom.component';
import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
  declarations: [ColorinterfaceComponent, TemplatesComponent, CustomComponent],
  imports: [CommonModule, FormsModule, ColorPickerModule],
  exports: [ColorinterfaceComponent],
})
export class ColorInterfaceModule {}
